<div class="radio-group">
  <label>{{ field.label | i18nextEager }} {{ field.required ? '*' : '' }}</label>
  <div class="radios">
    @for (option of field.options; track option.value) {
      <bdeo-radio
        value="option.value"
        text="{{ option.name | i18nextEager }}"
        name="{{ field.label }}"
        size="medium"
        [checked]="field.value === option.value"
        (change)="changeHandler(option.value)"
      ></bdeo-radio>
    }
  </div>
</div>
